import api from './api';

export const createFolder = (body) => api.post(`/v1/tenant/folder/create`, body);

export const renameFolder = (body) => api.post(`/v1/tenant/folder/rename`, body);

export const duplicateFolder = (folderUuid) => api.post(`/v1/folder/${folderUuid}/duplicate`);

export const listFoldersByTenant = (body) => api.post(`/v1/tenant/folder/list`, body);

export const tenantRenameFolder = (body) => api.post(`/v1/tenant/folder/rename`, body);

